import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Destinations', to: '/destinations' },
  { label: 'Services', to: '/services' },
  { label: 'Process', to: '/process' },
  { label: 'Success', to: '/success' },
  { label: 'Contact', to: '/contact' },
];

function Header() {
  return (
    <header className="go-header">
      <div className="go-container go-header__top">
        <div className="go-header__contact-row">
          <a href="tel:+918758637022">Call: +91 87586 37022</a>
          <a href="mailto:info@vedanskrix.com">Email: info@vedanskrix.com</a>
        </div>
      </div>

      <div className="go-container go-header__inner">
        <Link className="go-brand" to="/" aria-label="Vedanskrix Global Opportunities home">
          <img src="/logo.jpg" alt="Vedanskrix logo" />
          <div>
            <span className="go-brand__eyebrow">Vedanskrix</span>
            <strong>Global Opportunities</strong>
          </div>
        </Link>

        <nav className="go-nav" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'go-nav__link active' : 'go-nav__link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link className="go-header__cta" to="/contact">
          Free Counselling
        </Link>
      </div>
    </header>
  );
}

export default Header;
